import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import NumericInput from "../numericInput";
import { useWeightFilter } from "../filters/useWeightFilter";

const FilterWeight = ({ talentFilter, talentFilterTags, onAddFilter, controlledValues }) => {
  const {
    weightValues,
    setMin,
    setMax,
    isDisabled,
    buildWeightFilter,
  } = useWeightFilter(talentFilter, talentFilterTags, controlledValues);

  const handleAdd = () => {
    const payload = buildWeightFilter();
    if (!payload) return;

    onAddFilter("weight", payload);
  };

  return (
    <div className="p-[12px] w-[250px]">
      <div>Select weight range</div>

      <div className="grid grid-cols-2 gap-2">
        <div className="border rounded py-1 px-2">
          <div className="text-[11px]">MIN</div>
          <NumericInput
            className="border-none p-0"
            value={weightValues.start_value}
            placeholder="Example: 120"
            onChange={setMin}
          />
        </div>

        <div className="border rounded py-1 px-2">
          <div className="text-[11px]">MAX</div>
          <NumericInput
            className="border-none p-0"
            value={weightValues.end_value}
            placeholder="Example: 200"
            onChange={setMax}
          />
        </div>
      </div>

      <div className="text-right">
        <Button
          disabled={isDisabled}
          className="mt-[10px]"
          onClick={handleAdd}
          icon={<PlusOutlined />}
        >
          Add Filter
        </Button>
      </div>
    </div>
  );
};

export default FilterWeight;
